import Icon from '../components/Icon.vue'

Icon.register({
  'mars-stroke': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M372 64c6.6 0 12 5.4 12.1 12v78.9c0 10.7-12.9 16.1-20.5 8.5l-16.9-16.9-17.5 17.5 14.1 14.1c4.7 4.7 4.7 12.3 0 17l-28.3 28.3c-4.7 4.7-12.3 4.7-17 0l-14.1-14.1-18 18c14 22.2 22.1 48.5 22.1 76.7 0 79.5-64.5 144-144 144s-144-64.5-144-144 64.5-144 143.9-144c28.2 0 54.5 8.1 76.7 22.1l18-18-14.1-14.1c-4.7-4.7-4.7-12.3 0-17l28.3-28.2c4.7-4.7 12.3-4.7 17 0l14.1 14.1 17.5-17.5-16.9-16.9c-7.5-7.6-2.2-20.5 8.5-20.5h79zM144 384c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/mars-stroke.js
// module id = null
// module chunks = 